import { createFileRoute } from "@tanstack/react-router"
import BackofficeJobSearch from "modules/backoffice/components/jobSearch"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { z } from "zod"

const JobSearchSearchSchema = z.object({
  name: z.string().optional(),
  queue: z.enum(["CONVERSATION", "REALTIME", "BACKGROUND", "CAMPAIGN", "SERIAL"]).optional(),
  status: z.enum(["active", "waiting", "delayed", "failed", "completed", "paused"]).optional(),
  dataQuery: z.string().optional(),
  advanced: z.boolean().optional(),
  searched: z.boolean().optional(),
})

export const Route = createFileRoute("/_base/_auth/backoffice/jobSearch")({
  component: BackofficeJobSearch,
  validateSearch: (search) => JobSearchSearchSchema.parse(search),
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.jobSearch.title"),
    })
  },
})
